/**
 * @file
 * Attaches behaviors for handling header behaviors.
 *
 * @param {object} Drupal
 *   The Drupal object.
 * @param {function} once
 *   A function that ensures the behavior is only applied once.
 */
(function ($, Drupal, once) {
  'use strict';
  /**
   * Behavior to handle the submenu visibility.
   *
   * @type {Drupal~behavior}
   */
  Drupal.behaviors.headerSubMenuVisibility = {
    attach: function (context) {
      $(document).on('scroll', function () {
        $('.navbar_17 .navbar-we-mega-menu .we-mega-menu-ul .we-mega-menu-li .we-mega-menu-submenu').removeClass("sub-show");
        $(".form-item-suche .form-text").removeClass("form-text-active");
      });

      $('.navbar_17 .navbar-we-mega-menu .we-mega-menu-ul .we-mega-menu-li.dropdown-menu').on('mouseover', function () {
        $('.navbar_17 .navbar-we-mega-menu .we-mega-menu-ul .we-mega-menu-li .we-mega-menu-submenu').removeClass("sub-show");
        $(this).find('.we-mega-menu-submenu').addClass("sub-show");
      });
    }
  };
})(jQuery, Drupal, once);


